import { domainInputFields, domainInputOptions, hasCompleteDomainInputs, projectDomainInputValues } from './fieldInputContract.js';

/** The Result owns the primary answer; all other questions use the Domain form. */
export function resultInputSchema(domain) {
  return JSON.parse(JSON.stringify({ primary: domain?.primary || null, followUp: domain?.followUp || [] }));
}

// Compatibility with the original mark-sheet comment column. This maps a saved
// field, never a Domain name, and prevents two editors for the same answer.
export function hasResultCommentField(schema) {
  return schema?.followUp?.some(field => field.id === 'comment'
    && ['text', 'string'].includes(field.type) && field.active !== false && field.retired !== true) || false;
}

export function resultRowInputValues(schema, row) {
  return {
    ...(hasResultCommentField(schema) ? { comment: row?.comment || '' } : {}),
    ...(row?.fieldValues || {}),
    ...(schema?.primary?.id ? { [schema.primary.id]: row?.entry?.kind === 'status' ? null : row?.entry?.value ?? null } : {}),
  };
}

export function completeResultRowInputs(schema, row) {
  return hasCompleteDomainInputs(schema, resultRowInputValues(schema, row), { includePrimary: false, coerceNumbers: true });
}

export function publishedResultRowInputs(schema, row) {
  return projectDomainInputValues(schema, resultRowInputValues(schema, row), { includePrimary: false });
}

/** Frozen labels/options interpret answers in Queue, Records and revision history. */
export function resultInputDetails(schema, values) {
  return domainInputFields(schema).filter(field => field !== schema?.primary).flatMap(field => {
    const value = values?.[field.id];
    if (value == null || value === '') return [];
    const option = domainInputOptions(field).find(item => String(item.value) === String(value));
    return [{ id: field.id, label: field.label || field.id,
      value: option?.label || (typeof value === 'boolean' ? value ? 'Yes' : 'No' : String(value)) }];
  });
}
